import React, { useState } from 'react';
import styled from 'styled-components';
import { HowToGetBoxModal } from './HowToGetBoxModal';
interface WhitelistInfoPromptProps {}

const Info = styled.div`
    display: flex;

    padding: 1rem 0;

    ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
    `};

    a {
        color: rgba(53, 99, 243, 1);
        text-decoration: underline;
    }

    .text {
        font-size: 14px;
        color: #000;
        text-align: center;
    }

    .button {
        color: rgba(53, 99, 243, 1);
        font-size: 14px;
        cursor: pointer;
        width: auto;
    }
`;

export const WhitelistInfoPrompt: React.FC<WhitelistInfoPromptProps> = () => {
    const [isHowToGetBoxModalOpen, setIsHowToGetBoxModalOpen] = useState(false);

    const handleHowToGetBox = () => {
        setIsHowToGetBoxModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsHowToGetBoxModalOpen(false);
    };

    return (
        <>
            <Info>
                <div className="text">
                    It seems you missed the whitelist and box.
                    <p>
                        Feel free to double-check{' '}
                        <a
                            href="https://lazpad.fun/whitelist-campaign"
                            target="_blank"
                        >
                            here.
                        </a>
                    </p>
                    You can also get a box!
                    <span className="button" onClick={handleHowToGetBox}>
                        How?
                    </span>
                </div>
            </Info>

            <HowToGetBoxModal
                isOpen={isHowToGetBoxModalOpen}
                onClose={handleCloseModal}
            />
        </>
    );
};
